import React from 'react';

import { styled } from '@mui/material/styles';
import KImage from './KImage';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import noImage from './../images/noImage.png';
import Client from './Client';
import Autocomplete from '@mui/material/Autocomplete';
import DropDown from './DropDown';
import Config from './ClientConfig';
import BackOfficeConfig from './../Config';
import swal from 'sweetalert';

const MemoKImage = React.memo(function MemoKImage({ iref, edit, src, alt, saveBack }) {
  const image = { data: src, height: 128 }; // created inside memo
  return (
    <KImage
      iref={iref}
      edit={edit}
      image={image}
      imageText={alt}
      saveBack={saveBack}
      arrange="flex"
    />
  );
});

const VAL_COL_WIDTH = 100;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#273442",
    color: theme.palette.common.white,
    paddingLeft: "4px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingLeft: "4px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class KProductsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      // map of lineIref => bool (edit mode for each row)
      edit: {},
      products: [],
      options: {},
      canvas: null,
      saveURL: "",
      removeURL: "",
      parentIref: "",
      showConfirm: false,
      removeIref: "",
      productsSearch: [],
      inputByRow: {},
      addNew: false,
    };

    this.sendChangedState = this.sendChangedState.bind(this);
    this.saveBack = this.saveBack.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.changePriceType = this.changePriceType.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.changeProductName = this.changeProductName.bind(this);
    this.changeComboName = this.changeComboName.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.removeConfirm = this.removeConfirm.bind(this);
    this.removeCancel = this.removeCancel.bind(this);
    this.showConfirmDialog = this.showConfirmDialog.bind(this);

    this.productsSearch = this.productsSearch.bind(this);
    this.productChange = this.productChange.bind(this);
    this.pushData = this.pushData.bind(this);
  }

  componentDidMount() {
    if (this.props.products) this.setState({ products: this.props.products });
    if (this.props.edit) this.setState({ edit: this.props.edit });
    if (this.props.saveURL) this.setState({ saveURL: this.props.saveURL });
    if (this.props.removeURL) this.setState({ removeURL: this.props.removeURL });
    if (this.props.parentIref) this.setState({ parentIref: this.props.parentIref });

    // init per-row edit flags
    const editMap = {};
    (this.props.products || []).forEach(el => { editMap[el.iref] = false; });
    this.setState({ edit: editMap });
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return;

    if (this.props.products) {
      this.setState({ products: this.props.products });
      const editMap = {};
      (this.props.products || []).forEach(el => { editMap[el.iref] = false; });
      this.setState({ edit: editMap });
    }
    if (this.props.edit !== prevProps.edit && this.props.edit) this.setState({ edit: this.props.edit });
    if (this.props.saveURL && this.props.saveURL !== prevProps.saveURL) this.setState({ saveURL: this.props.saveURL });
    if (this.props.removeURL && this.props.removeURL !== prevProps.removeURL) this.setState({ removeURL: this.props.removeURL });
    if (this.props.parentIref && this.props.parentIref !== prevProps.parentIref) this.setState({ parentIref: this.props.parentIref });
  }

  sendChangedState() {}

  saveBack(product, lineIref) {
    const uProducts = [...this.state.products];
    for (let i = 0; i < uProducts.length; i++) {
      if (uProducts[i].iref === lineIref) {
        uProducts[i].product = product;
        break;
      }
    }
    this.setState({ products: uProducts });
  }

  pushData(lineIref) {
    const comboIref = lineIref;

    let data = null;
    for (let i = 0; i < this.state.products.length; i++) {
      if (this.state.products[i].iref === comboIref) {
        data = { ...this.state.products[i] }; // ⬅️ was missing braces in your version
        if (data.product && data.product.iref) {
          const productIref = data.product.iref;
          data.product = { iref: productIref };
        }
        break;
      }
    }
    if (!data) {
      swal("Error", "Add/Update product failed !", "error");
      return;
    }

    data.parentIref = this.state.parentIref;
    const rdata = this.state.client.pushData(this.state.saveURL, data);
    if (rdata) {
      const products = [...this.state.products];
      for (let i = 0; i < products.length; i++) {
        if (products[i].iref === comboIref) {
          products[i] = rdata;
          break;
        }
      }
      this.setState({ products });
      this.handleEditClick(comboIref);
      swal("Success", "Successfully added/modified product ! (" + rdata.iref + ")", "success", {
        buttons: false,
        timer: 2000,
      }).then(() => {
        this.setState({ addNew: false });
        this.props.productUpdated?.();
        this.setState({ somethingHasChanged: false });
      });
    } else {
      swal("Error", "Add/Update product failed !", "error");
    }
  }

  changeProductName(e) {
    const pid = e.target.id; // product.iref
    const val = e.target.value;
    const uProducts = [...this.state.products];
    for (let i = 0; i < uProducts.length; i++) {
      if (uProducts[i]?.product?.iref === pid) {
        if (!uProducts[i].product) uProducts[i].product = {};
        uProducts[i].product.name = val;
        break;
      }
    }
    this.setState({ products: uProducts });
  }

  changeComboName(e) {
    const lineIref = e.target.id; // combo line iref
    const val = e.target.value;
    const uProducts = [...this.state.products];
    for (let i = 0; i < uProducts.length; i++) {
      if (uProducts[i].iref === lineIref) {
        uProducts[i].name = val;
        break;
      }
    }
    this.setState({ products: uProducts });
  }

  changeValue(e) {
    const id = e.target.id;          // line iref
    const val = e.target.value;
    const products = [...this.state.products];
    for (let i = 0; i < products.length; i++) {
      if (products[i].iref === id) { products[i].priceValue = val; break; }
    }
    this.setState({ products });
  }

  changePriceType(lineIref, v) {
    const val = Number(v?.target?.value ?? v);
    const products = [...this.state.products];
    for (let i = 0; i < products.length; i++) {
      if (products[i].iref === lineIref) { products[i].priceType = val; break; }
    }
    this.setState({ products });
  }

  handleEditClick(lineIref) {
    const uEdit = { ...this.state.edit };
    uEdit[lineIref] = !uEdit[lineIref];
    this.setState({ edit: uEdit });
  }

  toggleAdd() {
    const addNew = !!this.state.addNew;
    const next = !addNew;

    const products = [...this.state.products];
    const edit = { ...this.state.edit };

    if (next) {
      const newRow = { iref: "newProduct", product: {}, priceType: 0, priceValue: "" };
      products.unshift(newRow);
      edit["newProduct"] = true;
    } else {
      if (products.length > 0 && products[0].iref === "newProduct") {
        products.shift();
        delete edit["newProduct"];
      }
    }
    this.setState({ addNew: next, products, edit });
  }

  removeProduct(lineIref) {
    if (lineIref === "newProduct") {
      // cancel inline add row
      this.toggleAdd();
      this.props.productUpdated?.();
      return;
    }
    const products = [...this.state.products];
    const edit = { ...this.state.edit };

    const payload = { iref: lineIref };
    const rdata = this.state.client.pushData(this.state.removeURL, payload);
    if (rdata) {
      if (rdata.status === "OK") {
        const idx = products.findIndex(p => p.iref === lineIref);
        if (idx >= 0) products.splice(idx, 1);
        delete edit[lineIref];

        this.setState({ products, edit });
        this.handleEditClick(lineIref);
        swal("Success", "Successfully removed product from combo!", "success", {
          buttons: false,
          timer: 2000,
        }).then(() => {
          this.props.productUpdated?.();
          this.setState({ somethingHasChanged: false });
        });
      } else {
        swal("Error", "Remove product failed !", "error");
      }
    }
  }

  showConfirmDialog(lineIref) {
    this.setState({ showConfirm: true, removeIref: lineIref });
  }

  removeConfirm() {
    const removeIref = this.state.removeIref;
    this.removeProduct(removeIref);
    this.setState({ showConfirm: false, removeIref: "" });
  }

  removeCancel() {
    this.setState({ showConfirm: false, removeIref: "" });
  }

  productsSearch(e) {
    const txt = (typeof e === "string" ? e : (e?.target?.value || "")).trim();
    if (txt.length < 3) {
      this.setState({ productsSearch: [] });
      return;
    }

    // << key change: send BOTH flags so your API returns results
    const queryData = { nameLike: txt, isForSale: 1 };
    const data = this.state.client.filterProducts(queryData);

    const list = Array.isArray(data?.products)
      ? data.products
      : Object.values(data?.products || {});

    const newProducts = list.map((f) => {
      const name = f?.name || "";
      let lineText = name;
      if (f?.pCategory?.name) {
        lineText += " (" + f.pCategory.name;
        if (f?.pSubCategory?.name) lineText += "/" + f.pSubCategory.name + ")";
        else lineText += ")";
      }
      return { key: f.iref, label: lineText };
    });

    this.setState({ productsSearch: newProducts });
  }

  productChange(e, v, prevProductIref, comboLineIref) {
    // CLEAR: user clicked the clear “x” or removed selection
    if (!v || !v.key) {
      const products = [...this.state.products];
      for (let i = 0; i < products.length; i++) {
        if (products[i].iref === comboLineIref || products[i]?.product?.iref === prevProductIref) {
          products[i].product = {};     // remove current product from the line
          break;
        }
      }
      this.setState({ products });
      return;
    }

    // OVERWRITE: fetch selected product by iref and replace it in the line
    const data = this.state.client.getData(Config.API_URL_PRODUCT, { iref: v.key });
    const list = Array.isArray(data?.products) ? data.products : Object.values(data?.products || {});
    const product = list[0] || {};

    const products = [...this.state.products];
    for (let i = 0; i < products.length; i++) {
      if (products[i].iref === comboLineIref || products[i]?.product?.iref === prevProductIref) {
        products[i].product = product;
        break;
      }
    }
    this.setState({ products });
  }

  render() {
    const productsCombo = (this.state.products || []).map((productCombo, idx) => {
      const product = productCombo.product || {};

      // row-scoped confirm dialog only
      const showConfirm = !!this.state.showConfirm && this.state.removeIref === productCombo.iref;

      // pick image
      let mainImage = noImage;
      if (product.productImage_product && product.productImage_product.length > 0) {
        mainImage = product.productImage_product[0].image;
        for (let i = 1; i < product.productImage_product.length; i++) {
          if (product.productImage_product[i].isMain) {
            mainImage = product.productImage_product[i].image;
          }
        }
      }
      const kImage = { data: mainImage, height: 128 };

      const productsSearch = this.state.productsSearch || [];

      const priceTypeNum = Number(productCombo.priceType);
      const showValue = priceTypeNum === 2;

      const priceType = (productCombo.priceType !== undefined)
        ? BackOfficeConfig.PRODUCT_COMBO_PRODCUT_TYPES[priceTypeNum]
        : "Unknown";

      // ✅ unique, stable row key (line iref preferred)
      const rowKey = productCombo.iref || (product?.iref ? `${product.iref}:${idx}` : `row-${idx}`);

      return (
        <TableRow key={rowKey}>
          <StyledTableCell>
            {this.state.edit[productCombo.iref] ? (
              (() => {
                const currentOption = product?.iref
                  ? { key: product.iref, label: product.name || String(product.iref) }
                  : null;
                const inputText =
                  this.state.inputByRow?.[productCombo.iref] ??
                  (currentOption?.label ?? "");
                const hasQuery = (inputText || "").trim().length >= 3;
                const options = hasQuery
                  ? (this.state.productsSearch && this.state.productsSearch.length
                      ? this.state.productsSearch
                      : (currentOption ? [currentOption] : []))
                  : (currentOption ? [currentOption] : []);
                return (
                  <Autocomplete
                    disablePortal
                    disableClearable={false}
                    id={`product-${productCombo.iref}`}
                    name="Product"
                    value={currentOption}                            // show current product
                    inputValue={inputText}                           // show what the user types
                    options={options}
                    filterOptions={(x) => x}
                    isOptionEqualToValue={(opt, val) => opt?.key === val?.key}
                    getOptionLabel={(opt) =>
                      typeof opt === "string" ? opt : (opt?.label ?? "")
                    }
                    sx={{ width: "260px", marginTop: 1 }}
                    onInputChange={(_, input) => {                   // typing drives search
                      this.setState(prev => ({
                        inputByRow: { ...prev.inputByRow, [productCombo.iref]: input }
                      }));
                      clearTimeout(this._searchT);
                      this._searchT = setTimeout(() => this.productsSearch(input), 180);
                    }}
                    onChange={(e, v) =>
                      this.productChange(e, v, product.iref, productCombo.iref)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Product (type keywords)" />
                    )}
                  />
                );
              })()
            ) : (
              <MemoKImage
                iref={product.iref}
                edit={this.state.edit[productCombo.iref]}
                src={mainImage}                // primitive string → stable compare
                alt={product.name}
                saveBack={this.saveBack}
              />
            )}
          </StyledTableCell>

          <StyledTableCell>
            {this.state.edit[productCombo.iref] ? (
              <TextField
                id={product.iref}
                label="Name"
                value={product.name || ''}
                variant="outlined"
                onChange={this.changeProductName}
                sx={{ minWidth: "90%", marginTop: 1 }}
                onFocus={(event) => { event.target.select(); }}
                inputProps={{ maxLength: "100" }}
              />
            ) : (
              product.name
            )}
          </StyledTableCell>

          <StyledTableCell>
            {this.state.edit[productCombo.iref] ? (
              <TextField
                id={productCombo.iref}
                label="Name in Combo"
                value={productCombo.name || ''}
                variant="outlined"
                onChange={this.changeComboName}
                sx={{ minWidth: "90%", marginTop: 1 }}
                onFocus={(event) => { event.target.select(); }}
                inputProps={{ maxLength: "100" }}
              />
            ) : (
              productCombo.name
            )}
          </StyledTableCell>

          <StyledTableCell>
            {this.state.edit[productCombo.iref] ? (
              <DropDown
                id={productCombo.iref}
                name="Price type"
                value={productCombo.priceType !== undefined ? productCombo.priceType : ''}
                doptions={BackOfficeConfig.PRODUCT_COMBO_PRODCUT_TYPES}
                hasIcons={false}
                minWidth={180}
                maxWidth={180}
                onDark={false}
                onChangeFunction={(e) => this.changePriceType(productCombo.iref, e)}
                marginTop={10}
                marginLeft={7}
                margin={0}
              />
            ) : (
              priceType
            )}
          </StyledTableCell>

          <StyledTableCell>
            {showValue ? (
              this.state.edit[productCombo.iref] ? (
                <TextField
                  id={productCombo.iref}
                  label="Value"
                  value={productCombo.priceValue || ''}
                  variant="outlined"
                  onChange={this.changeValue}    // ← already in your file
                  sx={{ width: VAL_COL_WIDTH, marginTop: 1 }}
                  onFocus={(event) => { event.target.select(); }}
                  inputProps={{ maxLength: "100" }}
                />
              ) : (
                productCombo.priceValue
              )
            ) : (
              ""
            )}
          </StyledTableCell>

          <StyledTableCell align="right" sx={{ padding: "1px" }}>
            <IconButton aria-label="settings" id={"ib-" + productCombo.iref} onClick={() => { this.handleEditClick(productCombo.iref); }}>
              <EditIcon
                id={productCombo.iref}
                sx={{ color: this.state.edit[productCombo.iref] ? "#8f241d" : "#e3e3e5" }}
              />
            </IconButton>

            {this.state.edit[productCombo.iref] ? (
              <IconButton aria-label="settings" id={productCombo.iref} onClick={() => { this.pushData(productCombo.iref); }}>
                <SaveIcon sx={{ color: "#4287f5" }} />
              </IconButton>
            ) : ""}

            {this.state.edit[productCombo.iref] ? (
              <IconButton aria-label="settings" id={productCombo.iref} onClick={() => { this.showConfirmDialog(productCombo.iref); }}>
                <DeleteForeverIcon sx={{ color: "#8f241d" }} />
              </IconButton>
            ) : ""}

            <Dialog
              open={showConfirm}
              TransitionComponent={Transition}
              keepMounted
              onClose={this.removeCancel}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{"Remove product ?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  This action will NOT delete the product ! This product will only be detached from the combo.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.removeCancel}>No</Button>
                <Button onClick={this.removeConfirm}>Yes</Button>
              </DialogActions>
            </Dialog>
          </StyledTableCell>
        </TableRow>
      );
    });

    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', textAlign: "middle", justifyContent: "center", alignItems: "center", paddingTop: "2px" }}>
        <Table sx={{ minWidth: 700, textAlign: "middle", justifyContent: "center" }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <IconButton aria-label="Add Product" title="Add Product" onClick={this.toggleAdd}>
                  <Avatar alt="Add Product" sx={{ width: 24, height: 24, color: "#273442" }}>
                    {this.state.addNew ? <FaMinusCircle /> : <FaPlusCircle />}
                  </Avatar>
                </IconButton>
                Product
              </StyledTableCell>
              <StyledTableCell align="left">Name</StyledTableCell>
              <StyledTableCell align="left">Name in Combo</StyledTableCell>
              <StyledTableCell sx={{width: 180}} align="left">Price Type</StyledTableCell>
              <StyledTableCell sx={{width: VAL_COL_WIDTH}} align="left">Value</StyledTableCell>
              <StyledTableCell align="right">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productsCombo}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default KProductsTable;
